import NoResultTransaction from './NoResultTransaction';

export default NoResultTransaction;
